// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c111d121","303":"326ab46a","404":"f3c8dcca"}[chunkId] + ".chunk.js";
};